import React from 'react';
import './index.scss';
import ACTImage from '../../../images/taking-asthma-control-test.svg';
import QuestionImage from '../../../images/group-of-question-marks.svg';

const Step = (props) => {
    return (

        <div className="screen instructions">
            <img className="actImage" src={ACTImage} alt="Taking Asthma Control Test" />
            <form onSubmit={props.formHandler} className="actView fadeIn">
                <div className="question">
                    <img className="questionImage" src={QuestionImage} alt="Icon: Group of Question Marks" />
                    <p className="quote">How to take the Childhood Asthma Control Test&trade;</p>
                    <dl>
                        <dt className="dsc">Step 1</dt>
                        <dd className="base-copy">Let your child respond to the first four questions (1 to 4). If your child needs help reading or understanding the question, you may help, but let your child select the response. For each question, make sure your child considers all four possible answers before choosing the best one for him or her.</dd>

                        <dt className="dsc">Step 2</dt>
                        <dd className="base-copy">Complete the remaining three questions (5 to 7) on your own and without letting your child's response influence your answers. There are no right or wrong answers. For each question, make sure you consider all six possible answers before choosing the best one.</dd>

                        <dt className="dsc">Step 3</dt>
                        <dd className="base-copy">Complete the test by clicking <strong>'SUBMIT.'</strong></dd>
                        <dt className="dsc">Step 4</dt>
                        <dd className="base-copy">Take the COMPLETED test to your child's healthcare provider to talk about your child's score.</dd>
                    </dl>
                </div>
                <button className="prev" type="button" onClick={props.restartHandler}><span className="hide-sm">Back</span></button>
                <button className="next" type="submit">Begin the Test</button>
            </form>
        </div>
    );
}

export default Step;
